/** Shown in the header. Keep in step with frontend/package.json's version. */
export const APP_VERSION = '1.0.0';
